import React from "react";
import { useSearchParams } from "react-router-dom";
import Navigation from "./Navigation";
import FusionPanel from "./fusion/FusionPanel";
import { isConsequenceKey } from "./fusion/fusionApi";

/**
 * /Fusion — the full-page entry to Universal Fusion. The same FusionPanel renders embedded on the
 * Dashboard; this page opens straight on the Organization chain list. `?consequence=<key>` seeds the
 * list's consequence filter; anything that is not an exact consequence key is dropped before any request.
 * `?view=coverage` opens the Data coverage view instead; any other value is ignored.
 */
const FusionPage = () => {
  const [params] = useSearchParams();
  const raw = params.get("consequence");
  const initialConsequence = isConsequenceKey(raw) ? raw : undefined;
  const initialView = params.get("view") === "coverage" ? "coverage" : undefined;
  return (
    <div className="min-h-screen bg-theme-primary">
      <Navigation />
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <div className="mb-4">
          <h1 className="text-3xl font-bold text-content-primary">Fusion</h1>
          <p className="mt-2 text-content-secondary">
            How findings from different modules connect through the same identity, device, AI asset or GRC control.
          </p>
        </div>
        <FusionPanel initialConsequence={initialConsequence} initialView={initialView} />
      </div>
    </div>
  );
};

export default FusionPage;
